import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom"
import { Toaster } from "react-hot-toast"
import { WalletProvider } from "./config/wagmi"
import Login from "./pages/Login"
import Register from "./pages/Register"
import ForgotPassword from "./pages/ForgotPassword"
import ResetPassword from "./pages/ResetPassword"
import Dashboard from "./pages/Dashboard"
import Portfolio from "./pages/Portfolio"
import ProtectedRoute from "./components/ProtectedRoute"


function App() {
  return (
    <WalletProvider>
      <Toaster
        position="top-right"
        toastOptions={{
          duration: 4000,
          style: {
            background: '#1a1a2e',
            color: '#00d9ff',
            border: '1px solid #00d9ff',
            borderRadius: '8px',
            fontSize: '14px',
          },
          success: {
            duration: 5000,
            iconTheme: {
              primary: '#00d9ff',
              secondary: '#1a1a2e',
            },
          },
          error: {
            duration: 6000,
            style: {
              background: '#1a1a2e',
              color: '#ff4444',
              border: '1px solid #ff4444',
            },
          },
        }}
      />
      <Router>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password/:token" element={<ResetPassword />} />
          <Route
            path="/dashboard"
            element={
              <ProtectedRoute>
                <Dashboard />
              </ProtectedRoute>
            }
          />
          <Route
            path="/portfolio"
            element={
              <ProtectedRoute>
                <Portfolio />
              </ProtectedRoute>
            }
          />
          <Route path="/" element={<Navigate to="/dashboard" replace />} />
        </Routes>
      </Router>
    </WalletProvider>
  )
}

export default App
